import { render, staticRenderFns } from "./msw-pref-file-download-report.vue?vue&type=template&id=b9670cb8&scoped=true&"
import script from "./msw-pref-file-download-report.vue?vue&type=script&lang=tsx&"
export * from "./msw-pref-file-download-report.vue?vue&type=script&lang=tsx&"
import style0 from "./msw-pref-file-download-report.vue?vue&type=style&index=0&id=b9670cb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9670cb8",
  null
  
)

export default component.exports